import type { ShiftFields } from '../api/generated/ShiftFields'
import type { ShiftSplit } from '../api/generated/ShiftSplit'
import { sliceBounds } from '../shifts/slices'
import { addMinutes } from '../shifts/time'

/** Most shifts the API creates in one series. */
export const MAX_SERIES_SHIFTS = 200

/** Hours (`HH:MM`) a position is staffed on a day; an end before the start is on the next day. */
export type DayRange = { day: string; start: string; end: string }

/** A position staffed over `ranges`, each cut by `split`. */
export type Series = { ranges: DayRange[]; split: ShiftSplit; required: number }

/** The shifts of a series, in order; a day without a valid range adds none. */
export function seriesShifts({ ranges, split, required }: Series): ShiftFields[] {
  const shifts: ShiftFields[] = []
  for (const { day, start, end } of [...ranges].sort((a, b) => a.day.localeCompare(b.day))) {
    if (!start || !end || start === end) continue
    const from = `${day}T${start}:00`
    const to = end < start ? addMinutes(`${day}T${end}:00`, 1440) : `${day}T${end}:00`
    const [first, ...ends] = sliceBounds(from, to, split)
    let startsAt = first
    for (const endsAt of ends) {
      if (startsAt)
        shifts.push({ starts_at: startsAt, ends_at: endsAt, required_volunteers: required })
      startsAt = endsAt
    }
  }
  return shifts
}
